<template>
  <div id="app">
    <div v-if="globalLoading">
      <b-spinner variant="primary" label="Spinning" style="margin-top: 300px;"></b-spinner>
    </div>
    <keep-alive
      v-else-if="isLoggedIn && !globalLoading && Object.keys(currAdmin).length > 0"
      :key="currAdmin.lgtime"
    >
      <router-view
        :currAdmin="currAdmin"
        :locParams="locPool[currAdmin.location]"
        v-on:adminupd="UpdateAdmin"
        v-on:glogout="googlelogOut()"
      ></router-view>
    </keep-alive>
    <TheLogin v-else :currLoc="currLoc" />
  </div>
</template>

<script>
import firebase from "../firebase";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
import TheLogin from "./components/TheLogin";

export default {
  name: "app",
  components: {
    TheLogin
  },
  data() {
    return {
      globalLoading: false,
      currAdmin: {},
      locPool: {
        londonderrydodge: {
          name: "Londonderry Dodge",
          pic: ""
        },
        northsidemitsubishi: { name: "NorthSide Mitsubishi", pic: "" },
        lanissan: { name: "La Nissan", pic: "" },
        lamazda: { name: "La Mazda", pic: "" },
        northsidenissan: { name: "NorthSide Nissan", pic: "" },
        rivercityhyundai: { name: "Rivercity Hyundai", pic: "" },
        sherwoodkia: { name: "Sherwood Kia", pic: "" },
        sherwoodnissan: { name: "Sherwood Nissan", pic: "" }
      },
      dbSync: {
        userOptionalName: "name",
        chatRoute: "routeChats",
        notificationsToEmail: "emailToNotes",
        showNotifications: "notificationsAllowed",
        popupAllowed: "popupAllowed",
        transcriptToEmail: "transcriptToEmail"
      },
      currLoc: "Harmsag",
      currlocService: "londonderrydodge"
    };
  },
  computed: {
    isLoggedIn() {
      return this.checkLogInFunc();
    }
  },
  watch: {
    currAdmin: function(val) {
      if (Object.keys(val).length > 0 && val.id) {
        if (this.$router.history.current.name == "Home") {
          this.$router.replace({ name: "Chat" });
        }
      } else {
        this.$router.replace({ name: "Home" });
      }
    }
  },
  created() {
    let href = window.location.href;
    if (window.location.href.includes("://")) {
      href = window.location.href.split("://")[1];
    }
    for (let ku in this.locPool) {
      if (href.split("/")[0].includes(ku)) {
        this.currLoc = this.locPool[ku].name;
        this.currlocService = ku;
        break;
      }
    }

    if (this.$route.query.locdev) {
      this.currlocService = this.$route.query.locdev;
      this.currLoc = this.locPool[this.currlocService].name;
    }
  },
  methods: {
    checkLogInFunc() {
      let that = this;
      this.globalLoading = true;

      return firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          return firebase
            .firestore()
            .collection(`admins/${that.currlocService}/adminsInfo`)
            .where("email", "==", user.email)
            .get()
            .then(function(querySnapshot) {
              if (querySnapshot.empty) {
                alert("Access Denied. Try to contact your manager");
                that.googlelogOut();
                return false;
              } else {
                let foundusrs = [];
                querySnapshot.forEach(function(doc) {
                  let data = doc.data();
                  data["docId"] = doc.id;
                  foundusrs.push(data);
                });

                if (foundusrs.length != 1) {
                  alert("Access Denied. Try to contact your manager");
                  that.googlelogOut();
                  that.globalLoading = false;
                  return false;
                } else {
                  that.currAdmin = foundusrs[0];

                  that.currAdmin["lgtime"] = Date.parse(new Date());
                  that.currAdmin[
                    "division"
                  ] = `${that.currAdmin.location}/${that.currAdmin.department}`;

                  if (that.currAdmin.googleId == "") {
                    that.FirstLogInAddGoogleId(user);
                  }

                  that.AdminLoggedIn();
                  return true;
                }
              }
            })
            .catch(function() {
              that.currAdmin["email"] = user.email;
              that.currAdmin["googleId"] = user.uid;
              that.globalLoading = false;
              that.googlelogOut();
            });
        } else {
          this.currAdmin = new Object();
          that.globalLoading = false;
          return false;
        }
      });
    },

    AdminLoggedIn() {
      let admrdbLocalVar = {
        time: Date(),
        processIn: 10000,
        adminId: this.currAdmin.id,
        taskName: "",
        adminEmail: this.currAdmin.email,
        hotRooms: [],
        presenceStatus: "on",
        routeChats: this.currAdmin.chatRoute,
        adminRole: this.currAdmin.role,
        emailToNotes: this.currAdmin.notificationsToEmail,
        notificationsAllowed: this.currAdmin.showNotifications,
        division: `${this.currAdmin.location}/${this.currAdmin.department}`,
        popupAllowed: this.currAdmin.popupAllowed,
        transcriptToEmail: this.currAdmin.transcriptToEmail,
        name: this.currAdmin.userOptionalName || this.currAdmin.user_google_name
      };

      this.UpdateOnlineAdminsRdb(admrdbLocalVar);

      this.globalLoading = false;
    },

    UpdateOnlineAdminsRdb(admrdb) {
      let that = this;

      firebase
        .database()
        .ref(`adminsOnline/${this.currAdmin.id}`)
        .once(
          "value",
          snapshot => {
            let res = snapshot.val();
            if (
              res !== null &&
              res !== undefined &&
              res.adminId != undefined &&
              res.adminId !== ""
            ) {
              //update presence to "on"
              firebase
                .database()
                .ref(`adminsOnline/${that.currAdmin.id}`)
                .update({
                  presenceStatus: "on",
                  hotRooms: []
                });
            } else {
              //manageadmins push data with status 'on'
              firebase
                .database()
                .ref(`adminsOnline/${that.currAdmin.id}`)
                .set(admrdb);
            }
          },
          errorObject => {
            console.log("The read failed: " + errorObject.code);
            //manageadmins push data with status 'on'
          }
        );
    },

    UpdateAdmin: function(v) {
      for (let key in this.dbSync) {
        let dk = this.dbSync[key];
        this.$set(this.currAdmin, key, v[dk]);
      }
    },

    googlelogOut() {
      this.$set(this.currAdmin, "id", "");
      this.currAdmin = new Object();
      firebase.auth().signOut();
    },

    FirstLogInAddGoogleId(u) {
      this.currAdmin["googleId"] = u.uid;
      this.currAdmin["user_google_name"] = u.displayName;
      this.currAdmin.userOptionalName =
        this.currAdmin.userOptionalName || u.displayName;

      firebase
        .firestore()
        .doc(`admins/${this.currlocService}/adminsInfo/${this.currAdmin.docId}`)
        .set(
          {
            googleId: this.currAdmin.googleId,
            user_google_name: u.displayName,
            userOptionalName: this.currAdmin.userOptionalName
          },
          { merge: true }
        );
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
}

body {
  font: 15px/1.3 "Open Sans", sans-serif;
  color: #5e5b64;
  text-align: center;
}
</style>